<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="px-4 py-2 card-border-blue">
              <b-card-body>
                <div v-if="error" class="mb-2">
                  <p class="alert alert-danger" style="margin: 0 .8rem 1px;">
                    <i class="glyphicon glyphicon-exclamation-sign text-danger"></i>
                    <small>Email and Password didn't match.</small>
                  </p>
                </div>
                <form @submit.prevent="submitLogin" class="login-form">
                  <p class="text-center">
                    <img src="/images/GS Logo Small.jpg" width="270" class="img-responsive">
                  </p>
                  <h4 class="text-muted text-center mb-3">Log into your account</h4>
                  <b-input-group class="mb-3 default">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icon-user"></i>
                      </span>
                    </div>
                    <input type="text" class="form-control" placeholder="Email" v-model="email" @change="checkEmail">
                  </b-input-group>
                  <b-input-group class="mb-3 default">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icon-lock"></i>
                      </span>
                    </div>
                    <input :type="isPasswordVisible ? 'text' : 'password'" class="form-control" placeholder="Password"
                      v-model="password">
                    <b-input-group-append>
                      <b-btn class="default btn-blue" @click="isPasswordVisible = !isPasswordVisible"><i
                          :class="['fa', isPasswordVisible ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i></b-btn>
                    </b-input-group-append>
                  </b-input-group>
                  <div v-if="error && attempt >= 3" style="margin-bottom: 10px;">
                    <p class="alert alert-warning" style="margin: 0 .8rem 1px;">
                      <small>
                        <i class="glyphicon glyphicon-question-sign text-warning"></i>
                        Having problem logging in? <br />
                        Contact us at support@grandshipper.com. </small>
                    </p>
                  </div>
                  <b-btn type="submit" class="d-block w-100 default rounded-pill btn-blue" style="padding: 2px 1px;"
                    :disabled="isLoading">
                    <span v-if="isLoading">
                      <b-spinner small type="grow"></b-spinner>
                      Loading...
                    </span>
                    <span v-else>
                      Login
                    </span>
                  </b-btn>
                  <div class="text-center" style="margin-top: 10px; font-size: 14px;">
                    <a href="/#/auth/forgot">Forgot password?</a>
                    <!-- <router-link to="/auth/forgot" class="btn px-0 btn-link default">Forgot password?</router-link> -->
                  </div>

                  <b-row class="justify-content-center mt-4">
                    <small>
                      Dont't have an account? <a href="/#/auth/register">Sign up for free</a>.
                    </small>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "Login",

  data() {
    return {
      isPasswordVisible: false,
      email: null,
      password: null,
      error: null,
      isLoading: false,
      attempt: 0,
    };
  },

  methods: {
    ...mapActions([
      "refreshUser",
      "refreshUserBalance",
      "refreshShippingServices",
      "refreshCarrierRules",
      "refreshNotification",
      "refreshShipsurance",
      "refreshEcommerceCount",
      "refreshImportCount",
    ]),
    ...mapMutations(["setEmployeeName"]),
    async checkEmail(e) {
      const email = this.email;
      const pattern = /@usps\.gov$/;
      // check that the email ends with usps.gov
      if (pattern.test(email)) {
        alert("Hi USPS Rep!  I see that you are trying to log in, but this page is for Customers only.  You will now be redirected to the USPS Portal log in page.");
        window.location = "https://usps.grandshipper.com/login";
        e.preventDefault();
        return;
      }
    },

    async submitLogin(e) {
      this.isLoading = true
      let tt = this;
      try {
        this.error = false;
        const { data } = await axios.post("login", { email: this.email, password: this.password });
        if (data.shipper) {
          localStorage.setItem('shipper', data.shipper);
          this.setEmployeeName(data.shipper);
        }

        // check Version
        const ver = process.env.MIX_VERSION;
        const local_ver = localStorage.getItem('version');
        // console.log("version", ver);
        // console.log("local_version", local_ver);
        // console.log(`${ver && local_ver !== ver? "true" : "false"}`);
        if (ver && local_ver !== ver) {
          localStorage.clear();
          localStorage.setItem('version', ver);
        }

        await this.refreshUser()
        await Promise.all([
          this.refreshUserBalance(),
          this.refreshShippingServices(),
          this.refreshCarrierRules(),
          this.refreshNotification(),
          this.refreshShipsurance(),
          this.refreshEcommerceCount(),
          this.refreshImportCount(),
        ]);

        const { next } = this.$route.query;
        //console.log("NEXT: ", next);

        if(next){
          const buff = Buffer.from(next, "base64");
          // console.log("REAL NEXT: ", buff.toString());
          window.location = buff.toString() 
        }else{
          this.$router.push("/orders/new-shipment");
          // window.location = "/#/orders/new-shipment";
        }
      } catch (e) {
        console.log(e);
        this.error = true;
        console.log("doing attempt")
        if (this.attempt > 3) this.attempt = 0;
        this.attempt += 1;
        this.isLoading = false
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Auth/Login.vue